<template>
  <div>
    <b-tooltip
      target="warningCertificadoVencido"
      placement="bottom"
    >
      Atenção! Certificado vencido. Clique aqui para atualizar.
    </b-tooltip>
    <font-awesome-icon
      v-if="hasCertificadoVencido"
      id="warningCertificadoVencido"
      class="warning-certificado"
      :icon="['fas', 'triangle-exclamation']"
      fade
      size="lg"
      @click="$router.push({ name: 'certificado-view', query: { filtroRapido: 'Vencidos' } })"
    />
  </div>
</template>

<style lang="scss">
.warning-certificado {
  background-color: #f20d0d;
  padding: 8px;
  border-radius: 50%;
  color: yellow;
}
</style>

<script>
/* eslint-disable no-param-reassign */
import { ref, onBeforeUnmount, onMounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import EventBus from '@app/shared/mixins/event-bus/eventBus'
import api from '@/app/certificado-digital/shared/services/api'

export default {
  components: {
  },
  directives: {
    Ripple,
  },
  setup() {
    // tipo correto (boolean em vez de array)
    const hasCertificadoVencido = ref(false)

    // tratamento de erros e logs de diagnóstico
    const buscarCertificadoVencido = async () => {
      try {
        const response = await api.getCertificadoVencido()
        hasCertificadoVencido.value = response.data
      } catch (error) {
        this.$error('[buscarCertificadoVencido] Erro ao buscar:', error)
      }
    }

    // Corrigido: handler nomeado (para poder fazer $off depois)
    const handleAtualizaCertificados = () => {
      buscarCertificadoVencido()
    }

    // Busca inicial e registro do listener
    onMounted(() => {
      buscarCertificadoVencido()

      // Registra listener
      EventBus.$on('atualizaCertificadosVencidos', handleAtualizaCertificados)
    })

    // Limpar listener ao desmontar para evitar memory leak
    onBeforeUnmount(() => {
      EventBus.$off('atualizaCertificadosVencidos', handleAtualizaCertificados)
    })

    return {
      hasCertificadoVencido,
    }
  },
}
</script>
